import PropTypes from 'prop-types'
import R from 'ramda'
import { Link } from 'react-router-dom'

import { Box, Icon, Text, Link as A, Container } from '@redriverpress/system'

const RouteShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  external: PropTypes.bool,
})

const LinkWrapper = ({ route }) => {
  if (route.external)
    return (
      <A color='black' href={route.to}>
        {route.label}
      </A>
    )
  return <Link to={route.to}>{route.label}</Link>
}

LinkWrapper.propTypes = { route: RouteShape.isRequired }

export default function Breadcrumbs({ routes, ...props }) {
  const trimmedRoutes = R.dropLast(2, routes)
  const penultimateRoute = R.last(R.init(routes))
  const lastRoute = R.last(routes)

  return (
    <Container as='nav' fontSize={0} py={[2, null, 3]} {...props}>
      {trimmedRoutes.map(route => (
        <Box display={['none', null, 'inline']} key={route.label}>
          <LinkWrapper route={route} />
          <Icon icon='angle-right' fontSize='12px' px={2} />
        </Box>
      ))}
      <Box display='inline'>
        <Icon
          icon='angle-left'
          pr={2}
          fontSize='12px'
          display={['inline', null, 'none']}
        />
        <LinkWrapper route={penultimateRoute} />
        <Icon
          icon='angle-right'
          px={2}
          fontSize='12px'
          display={['none', null, 'inline']}
        />
      </Box>
      <Box display={['none', null, 'inline']}>
        <Icon
          icon='angle-left'
          pr={2}
          fontSize='12px'
          display={['inline-block', null, 'none']}
        />
        <Text as='span'>{lastRoute.label}</Text>
      </Box>
    </Container>
  )
}

Breadcrumbs.propTypes = {
  routes: PropTypes.arrayOf(RouteShape).isRequired,
}
